import { Reducer } from 'redux';
import { Maintenance } from "models/Maintenance";
import { IMaintenanceActions, MaintenanceActionType } from "redux/actions/settings/MaintenanceActions";

const initialState: Maintenance[] | null = null;
export const maintenancesReducer: Reducer<Maintenance[] | null, IMaintenanceActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MaintenanceActionType.FETCH_MAINTENANCES_SUCCESS:
                {
                    return action.returnPayload as Maintenance[];
                }
            case MaintenanceActionType.ADD_MAINTENANCE_SUCCESS:
                {
                    let newMaintenances = [...state!];
                    newMaintenances.push({ ...action.returnPayload } as Maintenance)
                    return newMaintenances;
                }
            case MaintenanceActionType.EDIT_MAINTENANCE_SUCCESS:
            case MaintenanceActionType.DELETE_MAINTENANCE_SUCCESS:

                {
                    let newMaintenances = [...state!];
                    const updatedMaintenance = { ...action.returnPayload } as Maintenance;
                    newMaintenances = newMaintenances.map(nm => nm.id === updatedMaintenance.id ? updatedMaintenance : nm);
                    return newMaintenances;
                }
            default:
                return state;
        }
    };
